import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { wldOrLegacyDocUploadResolver } from '@shared/mfe-resolver/wld-or-legacy-doc-upload.resolver';

import { MultiTriageGuard, TransactionsGuard, TriageGuard } from './core/guards';
import { AuthGuard } from './core/guards/auth/auth.guard';
import { ClientDataGuard } from './core/guards/client/client-data.guard';
import { IncapacitatedGuard } from './core/guards/incapacitated/incapacitated.guard';
import { InitStateGuard } from './core/guards/init-state/init-state.guard';
import { SecureContainerComponent } from './secure/secure-container/secure-container.component';

export const multiInheritanceRoutes: Routes = [
  {
    path: 'multi-inheritance',
    children: [
      {
        path: 'triage',
        canActivate: [MultiTriageGuard],
        loadChildren: () =>
          import('./public/multi-triage/multi-triage.module').then((m) => m.MultiTriageModule),
      },
      {
        path: 'trust-triage',
        canActivate: [TriageGuard],
        loadChildren: () =>
          import('./public/multi-trust-triage/multi-trust-triage.module').then(
            (m) => m.MultiTrustTriageModule,
          ),
      },
      {
        path: 'summary',
        loadChildren: () =>
          import('./public/multi-triage-summary/multi-triage-summary.module').then(
            (m) => m.MultiTriageSummaryModule,
          ),
      },
    ],
  },
  {
    path: 'secure/multi-inheritance',
    canActivate: [AuthGuard, ClientDataGuard, InitStateGuard, IncapacitatedGuard],
    component: SecureContainerComponent,
    children: [
      // multi inheritance secure pages
      {
        path: 'decedent-info',
        loadChildren: async () =>
          import('./secure/decedent-info/decedent-info.module').then((m) => m.DecedentInfoModule),
      },
      {
        path: 'decedent-information',
        loadChildren: () =>
          import(
            './secure/multi-inheritance/decedent-info/multi-inheritance-decedent-info.module'
          ).then((m) => m.MultiInheritanceDecedentInfoModule),
      },
      {
        path: 'upload',
        resolve: {
          'doc-upload-mfe': wldOrLegacyDocUploadResolver,
        },
        loadChildren: () =>
          import('./secure/document-upload/document-upload.module').then(
            (m) => m.DocumentUploadModule,
          ),
      },
      {
        path: 'account-triage',
        loadChildren: () =>
          import('./secure/account-triage/account-triage.module').then(
            (m) => m.AccountTriageModule,
          ),
      },
      {
        path: 'estate',
        canActivate: [TransactionsGuard],
        loadChildren: () => import('./secure/estate/estate.module').then((m) => m.EstateModule),
      },
      {
        path: 'personal-info',
        loadChildren: () =>
          import('./secure/personal-info/personal-info.module').then((m) => m.PersonalInfoModule),
      },
      {
        path: 'contact-info',
        loadChildren: () =>
          import('./secure/contact-info/contact-info.module').then((m) => m.ContactInfoModule),
      },
      {
        path: 'settlement-fund',
        canActivate: [TransactionsGuard],
        loadChildren: () =>
          import('./secure/settlement-fund/settlement-fund.module').then(
            (m) => m.SettlementFundModule,
          ),
      },
      {
        path: 'employment',
        loadChildren: () =>
          import('./secure/employment/employment.module').then((m) => m.EmploymentModule),
      },
      {
        path: 'terms',
        canActivate: [TransactionsGuard],
        loadChildren: () => import('./secure/terms/terms.module').then((m) => m.TermsModule),
      },
      {
        path: '',
        loadChildren: () =>
          import('./secure/client-due-diligence/client-due-diligence.module').then(
            (m) => m.ClientDueDiligenceModule,
          ),
      },
      {
        path: 'new-account-review',
        canActivate: [TransactionsGuard],
        loadChildren: () =>
          import('./secure/new-account-review/new-account-review.module').then(
            (m) => m.NewAccountReviewModule,
          ),
      },
      {
        path: 'trust-info',
        canActivate: [TransactionsGuard],
        loadChildren: () =>
          import('./secure/trust-info/trust-info.module').then((m) => m.TrustInfoModule),
      },
      {
        path: 'trust-tax-info',
        canActivate: [TransactionsGuard],
        loadChildren: () =>
          import('./secure/trust-tax-info/trust-tax-info.module').then((m) => m.TrustTaxInfoModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(multiInheritanceRoutes)],
  exports: [RouterModule],
})
export class MultiInheritanceRoutingModule {}
